module.exports = __webpack_public_path__ + "img/Ithaki.769b5da1.png";